import React from 'react';

import CommonImage from '@/components/CommonImage';

const BuyerRequestModal = () => {
	return (
		<div className="popup-wrapper buyer-request-details-modal width-784-dialog">
			<div className="common-popup products-upload-modal">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-14 mb-0">Enter material request details</h3>
					</div>
					<div className="close-btn">
						<img src="/icons/close.svg" alt="close" />
					</div>
				</div>
				<div className="common-popup-body scroll-y-label body-scroll">
					<div className="row">
						<div className="col-md-12 pr-2">
							<div className="upload-img mb-2">
								<div className="file-uploader small upload-design-image mb-4 mb-sm-0">
									<label className="drag-upload" htmlFor="drag-upload" />
									<input
										accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf, image/*"
										className="file-upload"
										name="image"
										type="file"
									/>
								</div>
								{/* <div class="file-editing">
                                <img src=" /images/supplier2.jpg" alt="edit">
                                <div class="action-icon">
                                    <img width="20px" src=" /icons/upload-gray.svg" alt="check">
                                </div>
                            </div> */}
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-group">
								<div className="select-component">
									<label htmlFor="collection">Select collection / folder</label>
									<div className="click-box click mb-1" data-toggle="dropdown">
										<p className="regular-14 ">select</p>
										<CommonImage src=" /images/chevron_down.svg" />
									</div>
									<div className="dropdown-box dropdown-menu">
										<div className="m-0 search-filter">
											<div className="with-icon right-icon">
												<input placeholder="Search" type="text" />
												<span className="right-icon">
													<img src=" /icons/search.png" />
												</span>
											</div>
										</div>
										<div className="list-items scroll-y-label">
											<div className="single-item">
												<p>Garments</p>
											</div>
											<div className="single-item">
												<p>Item 2</p>
											</div>
											<div className="single-item">
												<p>Item 3</p>
											</div>
											<div className="single-item">
												<p>Item 4</p>
											</div>
											<div className="single-item">
												<p>Item 5</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-group">
								<div className="select-component">
									<label htmlFor="collection">Brand</label>
									<div className="click-box click mb-1" data-toggle="dropdown">
										<p className="regular-14 ">select</p>
										<CommonImage src=" /images/chevron_down.svg" />
									</div>
									<div className="dropdown-box dropdown-menu">
										<div className="m-0 search-filter">
											<div className="with-icon right-icon">
												<input placeholder="Search" type="text" />
												<span className="right-icon">
													<img src=" /icons/search.png" />
												</span>
											</div>
										</div>
										<div className="list-items scroll-y-label">
											<div className="single-item">
												<p>Garments</p>
											</div>
											<div className="single-item">
												<p>Item 2</p>
											</div>
											<div className="single-item">
												<p>Item 3</p>
											</div>
											<div className="single-item">
												<p>Item 4</p>
											</div>
											<div className="single-item">
												<p>Item 5</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-12">
							<div className="form-group">
								<label htmlFor="collection">Request needs to be served within*</label>
								<input type="date" placeholder="Material Name" />
							</div>
						</div>
						<div className="col-md-12">
							<div className="form-group">
								<label htmlFor="collection">Description</label>
								<textarea placeholder="Description" rows={3} />
							</div>
						</div>
					</div>
					{/* repeat row */}
					<div className="row repeat-row">
						<div className="col-md-6 ">
							<div className="form-group">
								<div className="select-component">
									<label htmlFor="collection">Fabric Type*</label>
									<div className="click-box click mb-1" data-toggle="dropdown">
										<p className="regular-14 ">select</p>
										<CommonImage src=" /images/chevron_down.svg" />
									</div>
									<div className="dropdown-box dropdown-menu">
										<div className="m-0 search-filter">
											<div className="with-icon right-icon">
												<input placeholder="Search" type="text" />
												<span className="right-icon">
													<img src=" /icons/search.png" />
												</span>
											</div>
										</div>
										<div className="list-items scroll-y-label">
											<div className="single-item">
												<p>Garments</p>
											</div>
											<div className="single-item">
												<p>Item 2</p>
											</div>
											<div className="single-item">
												<p>Item 3</p>
											</div>
											<div className="single-item">
												<p>Item 4</p>
											</div>
											<div className="single-item">
												<p>Item 5</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-group composition-item weight-item mb-0">
								<label>Weight*</label>
								<div className="d-flex">
									<input
										className="input-percentage"
										max={100}
										min="0.1"
										type="number"
										defaultValue
									/>
									<p className="percentage">%</p>
									<div className="select-component">
										<div className="form-group size36">
											<div className="select-component">
												<div
													className="click-box click mb-1"
													data-toggle="dropdown"
													tabIndex={0}
												>
													<p className="regular-14 ">GMV</p>
													<img alt="" src=" /images/chevron_down.svg" />
												</div>
												<div data-testid="wrapper">
													<div className="dropdown-box  dropdown-menu">
														<div className="m-0 search-filter">
															<div className="with-icon right-icon">
																<input
																	autoComplete="off"
																	placeholder="Composition"
																	type="text"
																	defaultValue
																/>
																<span className="right-icon">
																	<img src=" /icons/search.png" />
																</span>
															</div>
														</div>
														<div className="color-list-box">
															<li className="single-color-item single-item d-flex ">
																<span
																	className="single-item-focus"
																	tabIndex={0}
																>
																	Nylon
																</span>
															</li>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-group composition-item mb-0">
								<label>Composition*</label>
								<div className="d-flex">
									<input
										className="input-percentage"
										max={100}
										min="0.1"
										type="number"
										defaultValue
									/>
									<p className="percentage">%</p>
									<div className="select-component">
										<div className="form-group size36">
											<div className="select-component">
												<div
													className="click-box click mb-1"
													data-toggle="dropdown"
													tabIndex={0}
												>
													<p className="regular-14 " />
													<img alt="" src=" /images/chevron_down.svg" />
												</div>
												<div data-testid="wrapper">
													<div className="dropdown-box  dropdown-menu">
														<div className="m-0 search-filter">
															<div className="with-icon right-icon">
																<input
																	autoComplete="off"
																	placeholder="Composition"
																	type="text"
																	defaultValue
																/>
																<span className="right-icon">
																	<img src=" /icons/search.png" />
																</span>
															</div>
														</div>
														<div className="color-list-box">
															<li className="single-color-item single-item d-flex ">
																<span
																	className="single-item-focus"
																	tabIndex={0}
																>
																	Nylon
																</span>
															</li>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-group composition-item mb-0">
								<label className="invisible">.</label>
								<div className="d-flex">
									<input
										className="input-percentage"
										max={100}
										min="0.1"
										type="number"
										defaultValue
									/>
									<p className="percentage">%</p>
									<div className="select-component">
										<div className="form-group size36">
											<div className="select-component">
												<div
													className="click-box click mb-1"
													data-toggle="dropdown"
													tabIndex={0}
												>
													<p className="regular-14 " />
													<img alt="" src=" /images/chevron_down.svg" />
												</div>
												<div data-testid="wrapper">
													<div className="dropdown-box  dropdown-menu">
														<div className="m-0 search-filter">
															<div className="with-icon right-icon">
																<input
																	autoComplete="off"
																	placeholder="Composition"
																	type="text"
																	defaultValue
																/>
																<span className="right-icon">
																	<img src=" /icons/search.png" />
																</span>
															</div>
														</div>
														<div className="color-list-box">
															<li className="single-color-item single-item d-flex ">
																<span
																	className="single-item-focus"
																	tabIndex={0}
																>
																	Nylon
																</span>
															</li>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-12">
							<div className="add-new-color">
								<button className="button text size32 px-0">
									<img src="/icons/add-round.svg" alt="add" />
									<span className="ml-1">Add color</span>
								</button>
							</div>
						</div>
					</div>

					<div className="add-new-design text-right">
						<button className="button text size32 px-0">
							<img src="/icons/add-round.svg" alt="add" />
							<span className="ml-1">Add Material</span>
						</button>
					</div>
				</div>

				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button className="button outline size32 ml-2">Cancel</button>
						<button className="button size32 ml-2">Submit</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default BuyerRequestModal;
